import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getArticleFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.articles.code.label',
      contentValue: `{{ ${entity}article.code }}`,
      description: 'templates.articles.code.description',
    },
    {
      label: 'templates.articles.name.label',
      contentValue: `{{ ${entity}article.name }}`,
      description: 'templates.articles.name.description',
    },
    {
      label: 'templates.articles.base_price.label',
      contentValue: `{{ ${entity}article.base_price }}`,
      description: 'templates.articles.base_price.description',
    },
    {
      label: 'templates.articles.credit_price.label',
      contentValue: `{{ ${entity}article.credit_price }}`,
      description: 'templates.articles.credit_price.description',
    },
    {
      label: 'templates.articles.booking_price_type.label',
      contentValue: `{{ ${entity}article.booking_price_type }}`,
      description: 'templates.articles.booking_price_type.description',
    },
    {
      label: 'templates.articles.slots_number.label',
      contentValue: `{{ ${entity}article.slots_number }}`,
      description: 'templates.articles.slots_number.description',
    },
    {
      label: 'templates.articles.short_name.label',
      contentValue: `{{ ${entity}article.short_name }}`,
      description: 'templates.articles.short_name.description',
    },
  ];
};

export const templateArticle: EntityTemplateVariables = {
  fields: getArticleFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
